[
  {
    "id": "gpt-5-6-sol",
    "name": "GPT-5.6 Sol",
    "organization": "OpenAI",
    "kind": "model",
    "summary": "OpenAI's flagship GPT-5.6 capability tier for complex coding, reasoning, and agentic work."
  },
  {
    "id": "claude-opus-5",
    "name": "Claude Opus 5",
    "organization": "Anthropic",
    "kind": "model",
    "summary": "Anthropic's general frontier model released below Fable pricing."
  },
  {
    "id": "openai-ten-math-advances",
    "name": "Ten mathematics advances",
    "organization": "OpenAI",
    "kind": "research_result",
    "summary": "A collection of mathematical and theoretical-computer-science results produced with an unreleased OpenAI model."
  },
  {
    "id": "qwen3-8-max",
    "name": "Qwen3.8-Max",
    "organization": "Alibaba Qwen",
    "kind": "model",
    "summary": "Alibaba's frontier Qwen3.8 model announced with multimodal and long-context capabilities."
  },
  {
    "id": "muse-spark-1-2",
    "name": "Muse Spark 1.2",
    "organization": "Meta",
    "kind": "model",
    "summary": "Meta's coding-focused Muse update, introduced alongside the Muse Code agent harness."
  }
]

